import * as React from 'react';
import { Picker, Item } from '@adobe/react-spectrum';
import styles from './OperatorSelector.module.css';

export interface IOperator {
  key: string;
  label: string;
}

export interface IOperatorSelectorProps {
  operators: IOperator[];
  selectedOperator?: string;
  onOperatorChange: (operator: string) => void;
  label?: string;
  'aria-label'?: string;
}

export const OperatorSelector = React.forwardRef<HTMLDivElement, IOperatorSelectorProps>(
  (props, forwardedRef) => {
    const { operators, selectedOperator, onOperatorChange, label, 'aria-label': ariaLabel } = props;

    const handleSelectionChange = React.useCallback((key: React.Key | null) => {
      if (key) {
        onOperatorChange(key as string);
      }
    }, [onOperatorChange]);

    return (
      <div ref={forwardedRef} className={styles.operatorSelector}>
        <Picker
          aria-label={ariaLabel || label || 'Operator'}
          selectedKey={selectedOperator || null}
          onSelectionChange={handleSelectionChange}
          isQuiet
          UNSAFE_className={styles.operatorComboBox}
        >
          {operators.map((operator) => (
            <Item key={operator.key} textValue={operator.label}>
              {operator.label}
            </Item>
          ))}
        </Picker>
      </div>
    );
  }
);

OperatorSelector.displayName = 'OperatorSelector';

